// @school-apps/core/hub/grade-points — the standard 4.0 letter→points map (P4 X·3; previously
// maintained in two copies, so a grading-scale correction was a fix-in-two-copies bug). The map
// is shared verbatim by both apps; the GPA *math* stays app-body on purpose — unweighted (Estelle)
// vs credit-weighted (Alivia) is domain logic, the settled per-app difference.
//
// A through F with ± — no A+ (it maps to 4.0 anyway on a 4.0 scale) and no F± (doesn't exist):
//   A 4.0 · A- 3.7 · B+ 3.3 · B 3.0 · B- 2.7 · C+ 2.3 · C 2.0 · C- 1.7 · D+ 1.3 · D 1.0 · D- 0.7 · F 0.0
// PURE + BROWSER-SAFE — the app bundles import it via "@school-apps/core/hub/grade-points".
export const GRADE_POINTS = {
  "A": 4.0, "A-": 3.7,
  "B+": 3.3, "B": 3.0, "B-": 2.7,
  "C+": 2.3, "C": 2.0, "C-": 1.7,
  "D+": 1.3, "D": 1.0, "D-": 0.7,
  "F": 0.0,
};
export const GRADES = Object.keys(GRADE_POINTS);
